import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import { getDocumentTitle } from "../helpers";
import LoginLayout from "./LoginLayout";

/**
 * Wraps a component in the layout used for the login.
 *
 * Every call returns a new component class, so call it once at module level, not in a render.
 *
 * @param {ReactElement} WrappedComponent The React component to wrap.
 * @param {string}       documentTitle    The document title.
 *
 * @returns {ReactElement} The login layout with the wrapped component.
 */
export default ( WrappedComponent, documentTitle ) => {
	return class InLoginLayout extends Component {
		/**
		 * Renders the component.
		 *
		 * @returns {ReactElement} The rendered component.
		 */
		render() {
			return (
				<DocumentTitle title={ getDocumentTitle( documentTitle ) }>
					<LoginLayout>
						<WrappedComponent { ...this.props } />
					</LoginLayout>
				</DocumentTitle>
			);
		}
	};
};
